export const UIPage = {
    PLAYER_SEL: 0,
    LOBBY_SEL: 1,
    LOBBY: 2,
    GAMEPAD: 3,
}
